import { useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import Box from "@mui/material/Box";

import Sidebar from "@components/Sidebar/Sidebar";

import C from "@constants/constants";

import { useLoadCompanySearch } from "@queries/ipSearch.query";
import { usePortfolioQuery } from "@queries/portfolio.query";

import { useUserStore } from "@store/userStore";

import theme from "@theme/index";

function AppLoader() {
  const { authenticated } = useUserStore();
  const user = useUserStore();

  useLoadCompanySearch(user.currentSearch ?? "new");
  const location = useLocation();
  usePortfolioQuery();

  const sidebarExpanded = localStorage.getItem("sidebarExpanded");

  const [isSidebarExpanded, setIsSidebarExpanded] = useState<boolean>(sidebarExpanded === "true");

  const isNylasCallbackRoute = location.pathname === "/nylas/callback";

  if (!authenticated) {
    localStorage.setItem(C.REDIRECT_KEY, location.pathname);
  }
  if (authenticated && localStorage.getItem(C.REDIRECT_KEY) !== null && !window.opener) {
    const redirectPath = localStorage.getItem(C.REDIRECT_KEY);
    localStorage.removeItem(C.REDIRECT_KEY);
    return <Navigate to={redirectPath ?? "/"} />;
  }

  const handleSidebarToggle = () => {
    const newSidebarState = !isSidebarExpanded;
    localStorage.setItem("sidebarExpanded", newSidebarState ? "true" : "false");
    setIsSidebarExpanded(newSidebarState);
  };

  return authenticated ? (
    <Box
      sx={{
        backfaceVisibility: "hidden",
        background: theme.palette.background.paper,
        display: "grid",
        gridTemplateColumns: {
          md: "auto 1fr", // Use '1fr' for main content to take full remaining space
          xs: "100%", // In mobile view, sidebar will collapse
        },
        transition: "grid-template-columns 0.3s ease-in-out",
        willChange: "grid-template-columns",
      }}
    >
      {!isNylasCallbackRoute && <Sidebar isExpanded={isSidebarExpanded} toggleExpanded={handleSidebarToggle} />}
      <Box
        component="main"
        sx={{
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          height: {
            md: "100vh",
            xs: "auto",
          },
          overflowX: "hidden",
          width: "100%",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  ) : (
    <Navigate to="/login" />
  );
}

export default AppLoader;
